import type { ReactNode } from "react";

interface TimelineProps {
  children: ReactNode;
  className?: string;
}

/**
 * Timeline
 *
 * A vertical timeline component for displaying hierarchical or sequential information.
 * Connects items with a visual line to show relationships or flow.
 *
 * @example
 * ```tsx
 * <Timeline>
 *   <TimelineItem>First item</TimelineItem>
 *   <TimelineItem>Second item</TimelineItem>
 *   <TimelineItem>Third item</TimelineItem>
 * </Timeline>
 * ```
 */
export function Timeline({ children, className = "" }: TimelineProps) {
  return (
    <div className={`flex flex-col ${className}`.trim()} role="list">
      {children}
    </div>
  );
}
